/* eslint-disable react-hooks/exhaustive-deps */
import React from "react";
import ATMLoadingButton from "src/components/UI/atoms/ATMLoadingButton/ATMLoadingButton";
import ATMTextField from "src/components/UI/atoms/formFields/ATMTextField/ATMTextField";
import AccordianFormLayout from "src/components/layouts/AccordianFormLayout/AccordianFormLayout";
import { useOutletContext } from "react-router-dom";
import ATMSelect from "src/components/UI/atoms/formFields/ATMSelect/ATMSelect";
import useCountries from "src/hooks/useCountries";
import useCountryStates from "src/hooks/useCountryStates";
import useStateCities from "src/hooks/useStateCities";
import { handleValidNumber } from "src/utils/validations/numberInput";
import ATMMultiSelect from "src/components/UI/atoms/formFields/ATMMultiSelect/ATMMultiSelect";
import useBranches from "src/hooks/useGetBranches";

const StudentContactInformation = () => {
  const [{ formikProps }]: any = useOutletContext();
  const { values, setFieldValue, isSubmitting, handleBlur, errors } =
    formikProps;
  const { countries, isDataLoading: isCountriesLoading } = useCountries();
  //   Get All Branched
  const { branches, isDataLoading: isBranchLoading } = useBranches();
  const { countryStates, isDataLoading: isCountryStatesLoading } =
    useCountryStates(values?.countryId?._id || "");
  const { stateCities, isDataLoading: isStateCitiesLoading } = useStateCities(
    values?.stateId?._id || ""
  );

  return (
    <div className="">
      <div className="border-l-[3px] border-primary-dark px-3 py-1  my-2 font font-medium text-[18px] sticky top-0 bg-white  text-primary-dark">
        Information
      </div>
      <div className="my-1 font-semibold text-red-500">
        {errors?.any_one_contact && (
          <div>
            Please enter any one filed among Mobile number , Email And Other
            Social Media Id's{" "}
          </div>
        )}
      </div>
      <div className="grid xl:grid-cols-3 md:grid-cols-2 grid-cols-1 gap-4">
        {/* Mobile Number */}
        <div className="">
          <ATMTextField
            name="mobile"
            value={values?.mobile}
            onChange={(e) =>
              handleValidNumber(e ,{forMobile : true})  && setFieldValue("mobile", e.target.value)
            }
            label="Mobile Number"
            placeholder="Enter Mobile Number"
            onBlur={handleBlur}
          />
        </div>
        {/* Name */}
        <div>
          <ATMTextField
            name="name"
            value={values?.name}
            onChange={(e) => setFieldValue("name", e.target.value)}
            label="Name"
            placeholder="Enter Name"
            onBlur={handleBlur}
          />
        </div>
        {/* UserName */}
        <div>
          <ATMTextField 
          disabled
            name="username"
            value={values?.username}
            onChange={(e) => setFieldValue("username", e.target.value)}
            label="User Name"
            placeholder="Enter User Name"
            onBlur={handleBlur}
          />
        </div>

        {/* Email */}
        <div className="">
          <ATMTextField
            name="email"
            value={values.email}
            onChange={(e) => setFieldValue("email", e.target.value)}
            label="Email"
            placeholder="Enter Email"
            onBlur={handleBlur}
          />
        </div>
        {/*WhatsApp Mobile Number */}
        <div>
          <ATMTextField
            name="whatsApp_mobile"
            value={values.whatsApp_mobile}
            onChange={(e) =>
              handleValidNumber(e ,{forMobile : true})  &&
              setFieldValue("whatsApp_mobile", e.target.value)
            }
            label="WhatsApp Number"
            placeholder="Enter WhatsApp Number"
            onBlur={handleBlur}
          />
        </div>
        {/*Emergency Contact number  */}
        <div>
          <ATMTextField
            name="emergency_contact_no"
            value={values.emergency_contact_no}
            onChange={(e) =>
              handleValidNumber(e ,{forMobile : true})  &&
              setFieldValue("emergency_contact_no", e.target.value)
            }
            label="Emergency Contact number  "
            placeholder="Enter Emergency Contact number  "
            onBlur={handleBlur}
          />
        </div>
        {/*address */}
        <div>
          <ATMTextField
            name="address"
            value={values.address}
            onChange={(e) =>
              handleValidNumber(e) && setFieldValue("address", e.target.value)
            }
            label="Address "
            placeholder="Enter Address "
            onBlur={handleBlur}
          />
        </div>
        

        {/* Country */}
        <div className="">
          <ATMSelect
            name="countryId"
            value={values.countryId}
            onChange={(newValue) => {
              setFieldValue("countryId", newValue);
              setFieldValue("stateId", "");
              setFieldValue("cityId", "");
            }}
            label="Country"
            placeholder="Select Country"
            options={countries}
            isLoading={isCountriesLoading}
            renderOption={(option, { context }) => {
              if (context === "menu") {
                return (
                  <div className="capitalize"> {option?.countryName} </div>
                );
              } else {
                return (
                  <div className="capitalize"> {option?.countryName} </div>
                );
              }
            }}
            isOptionEqualToValue={(option, selected) => {
              return option?._id === selected._id;
            }}
            isSearchedOption={(option, searchValue) => {
              return searchValue
                ? option?.data?.countryName?.includes(searchValue)
                : true;
            }}
          />
        </div>

        {/* State */}
        <div className="">
          <ATMSelect
            name="stateId"
            value={values.stateId}
            onChange={(newValue) => {
              setFieldValue("stateId", newValue);
              setFieldValue("cityId", "");
            }}
            label="State"
            placeholder="Select State"
            options={countryStates}
            isLoading={isCountryStatesLoading}
            renderOption={(option, { context }) => {
              if (context === "menu") {
                return <div className="capitalize"> {option?.stateName} </div>;
              } else {
                return <div className="capitalize"> {option?.stateName} </div>;
              }
            }}
            isOptionEqualToValue={(option, selected) => {
              return option?._id === selected._id;
            }}
            isSearchedOption={(option, searchValue) => {
              return searchValue
                ? option?.data?.stateName?.includes(searchValue)
                : true;
            }}
          />
        </div>

        {/* City */}
        <div className="">
          <ATMSelect
            name="cityId"
            value={values.cityId}
            onChange={(newValue) => {
              setFieldValue("cityId", newValue);
            }}
            label="City"
            placeholder="Select City"
            options={stateCities}
            isLoading={isStateCitiesLoading}
            renderOption={(option, { context }) => {
              if (context === "menu") {
                return <div className="capitalize"> {option?.cityName} </div>;
              } else {
                return <div className="capitalize"> {option?.cityName} </div>;
              }
            }}
            isOptionEqualToValue={(option, selected) => {
              return option?._id === selected._id;
            }}
            isSearchedOption={(option, searchValue) => {
              return searchValue
                ? option?.data?.cityName?.includes(searchValue)
                : true;
            }}
          />
        </div> 
        {/* Branch Name */}
        <div>
          <ATMMultiSelect
            name="branchId"
            value={values.branchId}
            label="Branch"
            placeholder="Select branch"
            isLoading={isBranchLoading}
            options={branches?.map((branch: any) => ({
              label: branch?.branchName,
              value: branch?._id,
            }))}
            onChange={(newValue) => setFieldValue("branchId", newValue)}
            onBlur={handleBlur}
          />
        </div>
      </div>
      <div className="mt-5">
        <AccordianFormLayout formHeading="OTHER" isOpen={true}>
          <div className="grid xl:grid-cols-3 md:grid-cols-2 grid-cols-1 gap-4 p-2">
            {/* Linkedin ID */}
            <div className="">
              <ATMTextField
                name="linkedin_id"
                value={values?.linkedin_id}
                onChange={(e) => setFieldValue("linkedin_id", e.target.value)}
                label="Linkedin ID"
                placeholder="Enter Linkedin ID"
                onBlur={handleBlur}
              />
            </div>
            {/* Twitter ID */}
            <div className="">
              <ATMTextField
                name="twitter_id"
                value={values?.twitter_id}
                onChange={(e) => setFieldValue("twitter_id", e.target.value)}
                label="Twitter ID"
                placeholder="Enter Twitter ID"
                onBlur={handleBlur}
              />
            </div>
            {/* Instagram ID */}
            <div>
              <ATMTextField
                name="instagram_id"
                value={values.instagram_id}
                onChange={(e) => setFieldValue("instagram_id", e.target.value)}
                label="Instagram ID"
                placeholder="Enter Instagram ID"
                onBlur={handleBlur}
              />
            </div>
            {/* Facebook ID */}
            <div className="">
              <ATMTextField
                name="facebook_id"
                value={values.facebook_id}
                onChange={(e) => setFieldValue("facebook_id", e.target.value)}
                label="Facebook ID"
                placeholder="Enter Facebook ID"
                onBlur={handleBlur}
              />
            </div>
            {/* Youtube ID */}
            <div className="">
              <ATMTextField
                name="youtube_id"
                value={values.youtube_id}
                onChange={(e) => setFieldValue("youtube_id", e.target.value)}
                label="Youtube ID"
                placeholder="Enter Youtube ID"
                onBlur={handleBlur}
              />
            </div>
          </div>
        </AccordianFormLayout>
      </div>

      <div className="flex justify-end mt-4">
        <ATMLoadingButton
          className="flex justify-end w-[90px] px-8"
          isLoading={isSubmitting}
          type="submit"
        >
          Save
        </ATMLoadingButton>
      </div>
    </div>
  );
};

export default StudentContactInformation;
